(function ($, Drupal) {

  'use strict';

  function onDocSearchFormReady(context) {
    const $elements = $(once('initSearchFormBehavior', 'body', context));
    $elements.each(function() {

      $("form#searchForm, form#searchPageForm, form#search-form, form#search-form-mob, form#search-form-page").submit(function(e){
        e.preventDefault();
        var searchTerm = $(this).find($('input[type="search"]')).val();
        window.location.replace("/search?keywords="+ searchTerm);
      });

      $('#search-close').click(function() {
        $('#search-overlay').fadeOut();
      });

      $('.search-lnk').click(function() {
        $('#search-overlay').fadeIn();
        $('#search-form input').focus();
      });

    });
  }
  Drupal.behaviors.initSearchForm = {
    attach: function (context) {
      onDocSearchFormReady();
    }
  };

})(jQuery, Drupal);
